// extracted by mini-css-extract-plugin
module.exports = {"item":"TabBarItem-module--item--35b4f0","icon":"TabBarItem-module--icon--4087a4","label":"TabBarItem-module--label--1ac881","active":"TabBarItem-module--active--c530dd"};